module.exports = __webpack_public_path__ + "static/media/james3.4c536a99.mp3";